import AppLayout from './layout/AppLayout';
import LogoBrand from './ui/LogoBrand';
import MirrorList from './MirrorList';
import { MAINTENANCE_COPY } from '../config/maintenanceCopy';
import './MaintenancePage.scss';

/**
 * @param {{ message?: string | null, reason?: 'admin' | 'unreachable' }} props
 */
export default function MaintenancePage({ message = null, reason = 'admin' }) {
    const copy = MAINTENANCE_COPY[reason];
    const showMirrors = reason === 'unreachable';

    return (
        <AppLayout showHeader={false} bare>
            <div className="maintenance-page">
                <div className="maintenance-page__hero">
                    <LogoBrand variant="hero" as="h1" className="maintenance-page__brand" />
                    <p className="maintenance-page__tagline">
                        Личный кабинет — теперь в браузере
                    </p>
                </div>

                <div className="maintenance-page__panel">
                    <div className="card maintenance-page__card">
                        <p className="maintenance-page__label">{copy.label}</p>
                        <h2 className="maintenance-page__title">{copy.title}</h2>
                        <p className="maintenance-page__text">{copy.text}</p>
                        {message && (
                            <div className="maintenance-page__notice">
                                <p className="maintenance-page__notice-text">{message}</p>
                            </div>
                        )}
                        {showMirrors && <MirrorList />}
                    </div>
                </div>
            </div>
        </AppLayout>
    );
}
